const fileSystem = {
    "C:\\Users\\Areen": {
        type: "dir",
        children: {
            "myself": {
                type: "dir",
                children: {
                    "resume": { 
                        type: "pdf", 
                        content: "Opens a link to my resume", 
                        open: { type: "link", href: "https://drive.google.com/file/d/1SFqrON_V-nNvMa-2T0gg5FNHE0T0zCS3/view?usp=sharing" }
                    },
                    "work-experience": { 
                        type: "ppt", 
                        content: "Work experience in presentation format", 
                        open: { type: "component", id: "ppt" }
                    }
                }
            },
            "skills": {
                type: "png",
                content: "Image showcasing my skills",
                open: { type: "component", id: "skills" }
            },
            "games": {
                type: "dir",
                children: {
                    "cat-quiz": { 
                        type: "app", 
                        content: "Cat Quiz App — try it out!", 
                        open: { type: "link", href: "https://which-cat-am-i.netlify.app/" }
                    },
                    "roll-ball": { 
                        type: "app", 
                        content: "Roll Ball Game — fun physics-based game in Unity", 
                        open: { type: "link", href: "https://areenoverclouds.github.io/Roll-a-Ball/" }
                    },
                    "hangman": { 
                        type: "app", 
                        content: "Hangman Game — guess the word", 
                        open: { type: "link", href: "https://oh-wow-hangman.netlify.app/" }
                    },
                    "nokia-snake": { 
                        type: "app", 
                        content: "Nokia Snake Game — classic snake game", 
                        open: { type: "link", href: "https://nokia-snake-game.vercel.app/" }
                    },
                    "coderly": { 
                        type: "app", 
                        content: "Code completion extension", 
                        open: { type: "link", href: "https://github.com/areenoverclouds/coderly-extension" }
                    },
                    "vision": { 
                        type: "app", 
                        content: "AR world with penguins", 
                        open: { type: "link", href: "https://drive.google.com/file/d/114QjzKWwW8sKfIEF_d6cN8PgIxH3EpCE/view" }
                    },
                    "sand-simulator": { 
                        type: "app", 
                        content: "Sand-fall simulation", 
                        open: { type: "link", href: "https://sand-simulation.vercel.app" }
                    }
                }
            },
            "network": {
                type: "dir",
                children: {
                    "linkedin": { 
                        type: "file", 
                        content: "Areen's LinkedIn profile", 
                        open: { type: "link", href: "https://linkedin.com/in/areen-kaur" }
                    },
                    "github": { 
                        type: "file", 
                        content: "Areen's GitHub profile", 
                        open: { type: "link", href: "https://github.com/areenoverclouds" }
                    },
                    "dribbble": { 
                        type: "file", 
                        content: "Areen's Dribbble profile", 
                        open: { type: "link", href: "https://dribbble.com/areeen" }
                    },
                    "leetcode": { 
                        type: "file", 
                        content: "Areen's LeetCode profile", 
                        open: { type: "link", href: "https://leetcode.com/cloud-nine" }
                    },
                    "gfg": { 
                        type: "file", 
                        content: "Areen's GFG profile", 
                        open: { type: "link", href: "https://auth.geeksforgeeks.org/user/kaurareen" }
                    }
                }
            },
            "message": {
                type: "app",
                content: "Leave a message for me here :)",
                open: { type: "component", id: "message" }
            },
            "information": {
                type: "app",
                content: "Description about what this website all really is",
                open: { type: "component", id: "information" }
            }
        }
    }
};

export default fileSystem;
